<template>
  <form class="flex align-center checkbox-form" :class="additionalClasses">
    <!-- component prop -->
    <input type="checkbox" name="pay-full-amout" id="pay-full-amout">
    <!-- multi-language-text -->
    <label @click="handleClick" for="pay-full-amout" class="small-font-bold"
           :class="additionalClasses">{{ label }}</label>
  </form>
</template>

<script>
export default {
  props: {
    label: String,
    disabled: Boolean,
    checked: Boolean,
    autoCheck: Boolean
  },
  data () {
    return {}
  },
  computed: {
    additionalClasses () {
      return {
        disabled: this.$props.disabled,
        checked: this.$props.autoCheck,
        check: this.$props.checked
      }
    }
  },
  methods: {
    handleClick () {
      this.$emit('checkboxBoolean')
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox-form {
  &.disabled,
  &.checked {
    pointer-events: none;
  }

  input {
    position: absolute;
    visibility: hidden;
  }

  label {
    padding-left: 35px;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      height: 24px;
      width: 24px;
      background-color: #fff;
      border: 1px solid #999999;
      border-radius: 50%;
    }
  }

  input + label.disabled:not(.checked) {
    color: $border;

    &:before {
      background: $border;
    }
  }

  input + label.checked,
  input + label.check {
    &:before {
      background-color: #ed1a3b;
      border: 1px solid #ed1a3b;
    }

    &:after {
      content: '';
      position: absolute;
      height: 6px;
      width: 12px;
      border-bottom: 2px solid #fff;
      border-left: 2px solid #fff;
      top: 50%;
      left: 6px;
      transform: translate(0, -80%) rotate(-45deg);
    }
  }
}
</style>
